import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-8 md:pt-24 md:pb-12 overflow-hidden bg-main" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-122">
          {/* Text Content */}
          <div className="order-2 lg:order-1 space-y-8" data-id="element-123">
            <div className="inline-block text-accent text-xs uppercase tracking-widest font-semibold" data-id="element-124">
              MÉTODO FACELESS SPAIN (PACK DIGITAL)
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-title" data-id="element-125">
              Tu negocio invisible.
            </h1>

            <p className="text-lg md:text-xl text-body max-w-lg leading-relaxed" data-id="element-126">
              Guía paso a paso para crear una cuenta faceless y monetizar sin
              mostrar tu cara — con recursos para implementarlo desde el primer
              día.
            </p>

            <ul className="space-y-3 text-body" data-id="element-127">
              <li className="flex items-start" data-id="element-128">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-129" />
                <span data-id="element-130">Sin mostrar tu cara (ni tu nombre si no quieres)</span>
              </li>
              <li className="flex items-start" data-id="element-131">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-132" />
                <span data-id="element-133">Sin bailar, sin cámara frontal, sin exposición</span>
              </li>
              <li className="flex items-start" data-id="element-134">
                <Check className="h-5 w-5 text-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-135" />
                <span data-id="element-136">
                  Con estructura: qué publicar, qué decir y cómo monetizar
                </span>
              </li>
            </ul>

            <div className="pt-4" data-id="element-137">
              <Button size="lg" withArrow className="w-full sm:w-auto" href="#incluye" data-id="element-138">
                Ver qué incluye
              </Button>
              <p className="text-xs text-body mt-3 flex items-center justify-center sm:justify-start" data-id="element-139">
                Guía + 2 bonos incluidos · Acceso inmediato · Garantía 14 días
              </p>
            </div>

            <div className="pt-6 border-t border-[#D9D0C1] flex items-center gap-4" data-id="element-140">
              <div className="flex -space-x-2" data-id="element-141">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#E7D8C8] border-2 border-[#F6F1E8] overflow-hidden" data-id="element-142">
                    <img src={`https://randomuser.me/api/portraits/women/${40 + i}.jpg`} alt="" className="w-full h-full object-cover grayscale opacity-80" data-id="element-143" />
                  </div>)}
              </div>
              <p className="text-sm text-body" data-id="element-144">
                +450 mujeres ya lo han probado.
              </p>
            </div>
          </div>

          {/* Image Content */}
          <div className="order-1 lg:order-2 relative" data-id="element-145">
            <div className="relative z-10 rounded-sm overflow-hidden shadow-2xl border-8 border-card" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/7BdzpwBVBFR2pt528RXThu/faceless.png" alt="Método Faceless Spain Ebook en tablet y móvil" className="w-full h-auto object-cover" data-id="element-147" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-alt rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-148"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-accent rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-149"></div>
          </div>
        </div>
      </div>
    </section>;
}